/* global $ */
import Mojito from '../../../bower_components/mojito/lib/main';

export default class EventController extends Mojito.Controller {

    constructor(...args) {
        super(args);

        this.set('internal', false);
        this.set('isLoadMore', true);

        if (this._$.className.indexOf('internal') >= 0) {
            this.set('internal', true);
        }
    }

    loadMore() {
        let rows = this.$().find('tbody tr');

        if (this.get('isLoadMore')) {
            this.set('isLoadMore', false);
            rows.fadeIn();
        } else {
            this.set('isLoadMore', true);
            // rows.fadeOut();
            this.$().find('tbody tr:not(:nth-child(-1n+4))').fadeOut();

            $('html, body').animate({
                scrollTop: this.$().offset().top - 100
            }, 500);
        }
    }

    toggle(params) {
        if (this.get('internal')) {
            let collapse = $('#eventItemCollapse' + params.id);
            collapse.slideToggle();
        }
    }

    downloadICS(params) {
        $.post(
            document.location.origin + '/calendar-export/', params,
            function (data) {

                try {
                    window.open('data:text/calendar;charset=utf8,' + window.escape(data));
                } catch (e) {
                    console.log('Sorry, but it is not possible to download the calendar event!');
                }

            }).done(function () {
                // alert( "second success" );
            }).fail(function () {
                // alert( "error" );
            }).always(function () {
                // alert( "finished" );
            });
    }
}
